module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ee57a2d2ee8660a1e8c6a4a66bbc802f.png";